
import { Routes } from '@angular/router';
import { HomeComponent } from './home/home/home.component';
import { LoginComponent } from './home/login/login.component';
import { OrdersComponent } from './orders/orders.component';
import { UserComponent } from './user/user.component';
import { InvoiceMonitorComponent } from './invoice/invoice-monitor/invoice-monitor.component';
import { InvoiceDashboardComponent } from './invoice/invoice-dashboard/invoice-dashboard.component';
import { ExternalInvoiceMonitorComponent } from './invoice/external-invoice-monitor/external-invoice-monitor.component';
import { StatusViewerComponent } from './status-viewer/status-viewer.component';
import { ExternalDocumentUploadComponent } from './external-document/external-document-upload/external-document-upload.component';
import { ExternalDocumentProcessingComponent } from './external-document/external-document-processing/external-document-processing.component';
import { AuthenticationGuard } from './services/auth/authentication.guard';
import { NoAuthGuard } from './services/auth/no-auth.guard';

export const routes: Routes = [
    { path: '', component: LoginComponent, canActivate: [NoAuthGuard] },
    { path: 'home', component: HomeComponent, canActivate: [AuthenticationGuard] },
    { path: 'orders-monitor', component: OrdersComponent, canActivate: [AuthenticationGuard] },
    { path: 'avedi-invoice-monitor', component: InvoiceMonitorComponent, canActivate: [AuthenticationGuard] },
    { path: 'invoice-dashboard', component: InvoiceDashboardComponent, canActivate: [AuthenticationGuard] },
    { path: 'external-invoice-monitor', component: ExternalInvoiceMonitorComponent, canActivate: [AuthenticationGuard] },
    { path: 'external-document-upload', component: ExternalDocumentUploadComponent, canActivate: [AuthenticationGuard] },
    { path: 'external-document-processing', component: ExternalDocumentProcessingComponent, canActivate: [AuthenticationGuard] },
    { path: 'user', component: UserComponent, canActivate: [AuthenticationGuard] },
    { path: 'statuses-viewer', component: StatusViewerComponent, canActivate: [AuthenticationGuard] },
    {
        path: 'ia-config',
        loadComponent: () => import('./ia-config/ia-config-monitor/ia-config-monitor.component').then(m => m.IaConfigMonitorComponent),
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'logistic-operators',
        loadComponent: () => import('./logistic-operator/logistic-operator-monitor/logistic-operator-monitor.component').then(m => m.LogisticOperatorMonitorComponent),
        canActivate: [AuthenticationGuard]
    }
]
